import { useCallback, useState } from 'react';

export type BlocklistValidateDialogControllerReturn = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useBlocklistValidateDialogController = (): BlocklistValidateDialogControllerReturn => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    open,
    close,
  };
};
